/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRequestArticle
 */
export interface APIRequestArticle {
    /**
     * 
     * @type {string}
     * @memberof APIRequestArticle
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestArticle
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestArticle
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestArticle
     */
    description?: string;
}

/**
 * Check if a given object implements the APIRequestArticle interface.
 */
export function instanceOfAPIRequestArticle(value: object): value is APIRequestArticle {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIRequestArticleFromJSON(json: any): APIRequestArticle {
    return APIRequestArticleFromJSONTyped(json, false);
}

export function APIRequestArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestArticle {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function APIRequestArticleToJSON(value?: APIRequestArticle | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'number': value['number'],
        'description': value['description'],
    };
}

